<template>
    <div class="publicHeader">

        <template v-if="chunk.publication.type.name == 'PARALEL' && chunk.chunkType.name == 'TRANSLATE'">
            <span v-if="chunk.publication.paralelMetatitle && chunk.publication.paralelMetatitle != ''">{{ chunk.publication.paralelMetatitle }}</span>
            <span v-else>
                <span v-for="(author, index) in chunk.publication.authors" :key="author.id">
                    {{author.name}}<span class="pl_2" v-if="index < chunk.publication.authors.length - 1">, </span>
                </span>. {{chunk.publication.title}} ({{chunk.publication.year}})
            </span>

            <span :id="'chunktitle_'+chunk.id" class="qMark">i</span>

            <b-tooltip :target="'chunktitle_'+chunk.id" triggers="hover" placement="bottom" fallback-placement="clockwise" variant="info" custom-class="chunkHeadTooltip">
                <div>
                    <div v-if="chunk.publication.paralelMetatitle != null && chunk.publication.paralelMetatitle != ''"><b>{{chunk.publication.paralelMetatitle}}</b></div>
                    <div v-if="chunk.publication.authors != null && chunk.publication.authors.length > 0">
                        <b>Автор(ы): </b>
                        <span v-for="(author, index) in chunk.publication.authors" :key="author.id">{{author.name}}<span class="pl_2" v-if="index < chunk.publication.authors.length - 1">, </span></span>
                    </div>
                    <div v-if="chunk.publication.paralelTitle != null && chunk.publication.paralelTitle != ''"><b>Название: </b>{{chunk.publication.paralelTitle}}</div>
                    <div v-if="chunk.publication.genre != null && chunk.publication.genre != ''"><b>Жанр: </b>{{chunk.publication.genre}}</div>
                    <div 
                        v-if="chunk.publication.year != null && chunk.publication.year != '' && chunk.publication.year != 0">
                        <b>Год публикации: </b>{{chunk.publication.year}}
                    </div>
                    <div v-if="chunk.publication.paralelSource != null && chunk.publication.paralelSource != ''"><b>Источник: </b>{{chunk.publication.paralelSource}}</div>
                </div>
            </b-tooltip>
        </template>

        <template v-else>
            <span v-if="chunk.publication.metatitle && chunk.publication.metatitle != ''">{{ chunk.publication.metatitle }}</span>
            <span v-else>
                <span v-for="(author, index) in chunk.publication.authors" :key="author.id">
                    {{author.name}}<span class="pl_2" v-if="index < chunk.publication.authors.length - 1">, </span>
                </span>. {{chunk.publication.title}} ({{chunk.publication.year}})
            </span>

            <span :id="'chunktitle_'+chunk.id" class="qMark">i</span>

            <b-tooltip :target="'chunktitle_'+chunk.id" triggers="hover" placement="bottom" fallback-placement="clockwise" variant="info" custom-class="chunkHeadTooltip">
                <div>
                    <div v-if="chunk.publication.metatitle != null && chunk.publication.metatitle != ''"><b>{{chunk.publication.metatitle}}</b></div>
                    <div v-if="chunk.publication.authors != null && chunk.publication.authors.length > 0">
                        <b>Автор(ы): </b>
                        <span v-for="(author, index) in chunk.publication.authors" :key="author.id">{{author.name}}<span class="pl_2" v-if="index < chunk.publication.authors.length - 1">, </span></span>
                    </div>
                    <div v-if="chunk.publication.title != null && chunk.publication.title != ''"><b>Название: </b>{{chunk.publication.title}}</div>
                    <div v-if="chunk.publication.genre != null && chunk.publication.genre != ''"><b>Жанр: </b>{{chunk.publication.genre}}</div>
                    <div v-if="chunk.publication.createdate != null && chunk.publication.createdate != '' && chunk.publication.createdate != 0"><b>Год (дата) создания: </b>{{chunk.publication.createdate}}</div>
                    <div 
                        v-if="chunk.publication.type.name != 'PARALEL' && chunk.publication.year != null && chunk.publication.year != '' && chunk.publication.year != 0">
                        <b>Год публикации: </b>{{chunk.publication.year}}
                    </div>
                    <div v-if="chunk.publication.source != null && chunk.publication.source != ''"><b>Источник: </b>{{chunk.publication.source}}</div>
                    <!-- <div v-if="chunk.publication.theme != null"><b>Подкорпус: </b>{{chunk.publication.theme.title}}</div> -->
                    <div v-if="chunk.publication.dialekt != null && chunk.publication.dialekt != ''"><b>Диалект: </b>{{chunk.publication.dialekt}}</div>
                </div>
            </b-tooltip>
        </template>
    </div>
</template>

<script>
    export default {
        name: "publicationinfo",

        props: {
            chunk: {
                type: Object,
                default: null
            }
        },
    }
</script>

<style @scoped>
  div.publicHeader {color: grey;padding-bottom:5px;}
  .qMark {border:1px solid grey;border-radius:50%; padding: 0 6px; cursor:pointer;font-size: 12px;margin-left: 5px}
  .chunkHeadTooltip {text-align:left;}
  .chunkHeadTooltip .tooltip-inner {text-align:left;max-width: 500px;}
</style>